import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import MoneysIcon from "@assets/svg/MoneysIcon.svg?react";
import Input from "@Common/input";
import { PricingInformationFormWrapper } from "./styles";
import { IFormManualReservation } from "..";
import { FORM_REGEX_VALIDATORS } from "@utils";
import { use } from "i18next";

export default function PricingInformationForm() {
  /* ---------------------------------- Hooks --------------------------------- */
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<IFormManualReservation>();
  const watchCheckIn = watch("booking_information.checkIn");
  const watchCheckOut = watch("booking_information.checkOut");
  const watchNightPrice = watch("pricing_information.nightPrice");
  const watchOldNightPrice = watch("booking_information.nightPrice");
  /* --------------------------------- Effects -------------------------------- */
  useEffect(() => {
    setValue("pricing_information.nightPrice", watchOldNightPrice);
  }, []);
  useEffect(() => {
    const checkIn = dayjs(watchCheckIn);
    const checkOut = dayjs(watchCheckOut);

    if (!checkIn.isValid() || !checkOut.isValid()) return;

    const totalDays = checkOut.diff(checkIn, "days");
    const totalPrice =
      Number(watchNightPrice) * totalDays > 0
        ? Number(watchNightPrice) * totalDays
        : 0;

    setValue("pricing_information.totalPrice", totalPrice);
    setValue("booking_information.nightPrice", watchNightPrice);
  }, [watchCheckIn, watchCheckOut, watchNightPrice, setValue]);

  return (
    <PricingInformationFormWrapper>
      <div className="containerItem">
        <div className="containerSVG">
          <MoneysIcon />
        </div>
        <p>{t("COMMON.BOOKING_PRICE_DATA")}</p>
        <Input
          name="pricing_information.nightPrice"
          label={t("MANUALRESERVATION.NIGHTPRICE")}
          placeholder={t("MANUALRESERVATION.NIGHTPRICE")}
          registerOptions={{
            required: {
              value: true,
              message: t("MANUALRESERVATION.PLEASEENTERTHENIGHTRATE"),
            },
            pattern: {
              value: FORM_REGEX_VALIDATORS.digitsDecimal,
              message: t("MANUALRESERVATION.ONLYNUMBERSAREALLOWEDINTHISFIELD"),
            },
          }}
        />
        <Input
          name="pricing_information.totalPrice"
          label={t("MANUALRESERVATION.TOTALPRICEOFRESERVATION")}
          placeholder={t("MANUALRESERVATION.TOTALPRICEOFRESERVATION")}
          readonly
          registerOptions={{
            required: {
              value: true,
              message: t("MANUALRESERVATION.PLEASEENTERTHENIGHTRATE"),
            },
            pattern: {
              value: FORM_REGEX_VALIDATORS.digitsDecimal,
              message: t("MANUALRESERVATION.ONLYNUMBERSAREALLOWEDINTHISFIELD"),
            },
          }}
        />
      </div>
    </PricingInformationFormWrapper>
  );
}
